import store from '@/modules/login-extended/module/store';

export default { ...store };
